module.exports = __webpack_public_path__ + "static/media/grass_fed_beef_desktop_en.4f0624af.jpg";